
import { DOWNLOAD_PROGRESS } from "context/DownloadAssetsContext";
import { DOWNLAOD_MULTIPLE_ASSET, DOWNLOAD_READY_ASSETS_API } from "../components/Dam/DAM_API/urls";
import Axios from "./Axios";

export const startDownloadAssets = async (_data) => {
    const response = await Axios.post(
        DOWNLAOD_MULTIPLE_ASSET,
        _data,
        {
            validateStatus: () => true,
        },
    );
    // async job created
    if (response.status === 202) {
        return {
            status: response.data?.status,
            downloadId: response.data?.requestId,
        };
    }

    // backend says ready immediately
    if (response.status === 200) {
        return {
            status: "READY",
            downloadId: response.data?.id,
        };
    }

    throw new Error("Failed to start download");
};

const mapPhaseProgress = (phase, percent = 0) => {
  const cfg = DOWNLOAD_PROGRESS[phase];
  if (!cfg) return 0;

  if (cfg.start === cfg.end) return cfg.end;

  return Math.min(
    cfg.end,
    cfg.start +
      Math.floor(((cfg.end - cfg.start) * percent) / 100)
  );
};

export const downloadAssetsFile = async (_data, onProgress) => {
  const response = await Axios.get(
    `${DOWNLOAD_READY_ASSETS_API}/${_data.downloadId}`,
    {
      responseType: "blob",

      onDownloadProgress: (e) => {
        if (!e.total) return;

        const rawPercent = Math.round(
          (e.loaded * 100) / e.total
        );

        // 🔥 Dynamic mapping using config
        const mappedPercent = mapPhaseProgress(
          "DOWNLOADING",
          rawPercent
        );

        if (onProgress) {
          onProgress(mappedPercent);
        }
      },
    }
  );

  if (response.status !== 200) {
    throw new Error("File download failed");
  }

  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  let filename = "images.zip";
  const cd = response.headers["content-disposition"];
  if (cd) {
    const match = cd.match(/filename="(.+)"/);
    if (match) filename = match[1];
  }

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};
